import { useOutletContext } from "react-router-dom";
import { useMemo } from "react";
import { svg } from "../../Assets/svg";
import { RootState, useAppSelector } from "../../store";
import { useIsTimeVariant } from "../../helpers/appPackage";
import { isTimeAppNotification } from "./NotificationsDrawer";

interface NotificationButtonProps {
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  icon?: React.ReactNode;
  isHeader?: boolean;
}

const NotificationButton = ({
  onClick,
  className,
  style,
  icon,
  isHeader,
}: NotificationButtonProps = {}) => {
  const outletContext = useOutletContext<any>();
  const isTimeVariant = useIsTimeVariant();
  const { notificationData, notificationCount } = useAppSelector(
    (state: RootState) => state.notification,
  );

  const displayCount = useMemo(() => {
    return notificationCount || 0;
  }, [notificationCount]);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (outletContext?.setNotificationDrawer) {
      outletContext.setNotificationDrawer(true);
    }
  };

  const notificationIconToDisplay =
    icon ||
    (isHeader
      ? (svg as any)?.notificationIcon2 || (svg as any)?.notificationIcons2
      : svg?.notificationIcon);

  return (
    <div
      role="button"
      className={
        className ||
        (isHeader
          ? "svg-26 position-relative d-flex align-items-center justify-content-center"
          : "filterButton position-relative")
      }
      style={{ cursor: "pointer", ...style }}
      onClick={handleClick}
    >
      {notificationIconToDisplay}
      {displayCount > 0 ? (
        <span className="position-absolute badge customBadgeFont rounded-pill bg-danger">
          {displayCount}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};

export default NotificationButton;
